/**
 * Renders a `"lat, long"` pair for a detail field, guarding against the
 * backend sending non-finite values. The types declare `latitude` /
 * `longitude` as `number`, but this is external data (golden rule: never
 * trust it) — a `null` would otherwise render as the literal `"null,
 * null"`. Returns an empty string when either coordinate is missing so
 * the caller renders its placeholder (`"—"`).
 */
export function formatCoordinates(
  latitude: number | null | undefined,
  longitude: number | null | undefined,
): string {
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return "";
  return `${latitude}, ${longitude}`;
}
